import { render, staticRenderFns } from "./manageGroups.vue?vue&type=template&id=2ff0391f&lang=pug"
import script from "./manageGroups.vue?vue&type=script&lang=js"
export * from "./manageGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports